<template>
  <subpage-shell
    :eyebrow="trans.get('landing.subpages.ueber_uns.eyebrow')"
    :title-prefix="trans.get('landing.subpages.ueber_uns.title_prefix')"
    :title-grad="trans.get('landing.subpages.ueber_uns.title_grad')"
    :title-suffix="trans.get('landing.subpages.ueber_uns.title_suffix')"
    :cta-lede="trans.get('landing.subpages_shared.cta_lede_quiz_match')"
    nav-active="about"
  >
    <main class="prose">
      <h2>{{ trans.get('landing.subpages.ueber_uns.prose.h2_who') }}</h2>
      <p>
        {{ trans.get('landing.subpages.ueber_uns.prose.p1_prefix') }}
        <a href="/impressum">{{
          trans.get('landing.subpages.ueber_uns.prose.p1_link_impressum')
        }}</a
        >.
      </p>

      <h2>{{ trans.get('landing.subpages.ueber_uns.prose.h2_build') }}</h2>
      <p>{{ trans.get('landing.subpages.ueber_uns.prose.p2') }}</p>

      <h2>{{ trans.get('landing.subpages.ueber_uns.prose.h2_believe') }}</h2>
      <p>{{ trans.get('landing.subpages.ueber_uns.prose.p3') }}</p>
      <p>{{ trans.get('landing.subpages.ueber_uns.prose.p4') }}</p>

      <h2>{{ trans.get('landing.subpages.ueber_uns.prose.h2_safety') }}</h2>
      <p>
        {{ trans.get('landing.subpages.ueber_uns.prose.p5_prefix') }}
        <a href="/datenschutz">{{
          trans.get('landing.subpages.ueber_uns.prose.p5_link_privacy')
        }}</a
        >{{ trans.get('landing.subpages.ueber_uns.prose.p5_middle') }}
        <a href="/agb">{{ trans.get('landing.subpages.ueber_uns.prose.p5_link_agb') }}</a
        >{{ trans.get('landing.subpages.ueber_uns.prose.p5_suffix') }}
      </p>

      <h2>{{ trans.get('landing.subpages.ueber_uns.prose.h2_contact') }}</h2>
      <p>
        {{ trans.get('landing.subpages.ueber_uns.prose.p6_prefix') }}
        <a href="mailto:support@viluu.de">support@viluu.de</a>.
        {{ trans.get('landing.subpages.ueber_uns.prose.p6_suffix') }}
        <a href="/impressum">{{
          trans.get('landing.subpages.ueber_uns.prose.p6_link_impressum')
        }}</a
        >.
      </p>
    </main>
  </subpage-shell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';

export default {
  name: 'UeberUnsPage',
  components: { SubpageShell },
};
</script>
